import axios from 'axios';

// 메인 관리자 로그인 — 본부 포털(HQ, /hq)의 직원 계정과 세션을 그대로 쓴다. 로그인하면 hq-backend 가
// 쿠키 hq_session(path=/, httpOnly)을 심고, 관리자 API 는 nginx 와 각 서비스가 이 세션을 확인한다.
const http = axios.create({
  baseURL: '/api/hq/auth',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export interface HqStaff {
  id: string;
  name: string;
  team?: string;
  role: string;
}

export class HqAuthError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

const toError = (err: any) =>
  new HqAuthError(err?.response?.status || 0, err?.response?.data?.message || '본부 포털에 연결하지 못했습니다.');

export const hqAuthApi = {
  async me(): Promise<HqStaff> {
    try {
      const res = await http.get<{ staff: HqStaff }>('/me');
      return res.data.staff;
    } catch (err) {
      throw toError(err);
    }
  },
  async login(loginId: string, password: string): Promise<HqStaff> {
    try {
      const res = await http.post<{ staff: HqStaff }>('/login', { loginId, password });
      return res.data.staff;
    } catch (err) {
      throw toError(err);
    }
  },
  async logout(): Promise<void> {
    try {
      await http.post('/logout');
    } catch (err) {
      // 이미 끊긴 세션이면 그냥 로그인 화면으로 돌아간다
    }
  },
};
